/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PreferredWorkType = "Afternoon" | "Any" | "Morning" | "%future added value";
export type WorkPreferenceGoal_org = {
    readonly id: string;
    readonly userGoals: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly goalId: string;
                readonly name: string;
                readonly isDeleted: boolean;
                readonly options: {
                    readonly syncToGoogle: boolean;
                    readonly specificOptions: {
                        readonly preferredWorkType?: PreferredWorkType | undefined;
                    } | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "WorkPreferenceGoal_org";
};
export type WorkPreferenceGoal_org$data = WorkPreferenceGoal_org;
export type WorkPreferenceGoal_org$key = {
    readonly " $data"?: WorkPreferenceGoal_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"WorkPreferenceGoal_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "WorkPreferenceGoal_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000000
                    }
                ],
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "userGoals",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "GoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "goalId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isDeleted",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "GoalOptions",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "syncToGoogle",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "specificOptions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "preferredWorkType",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "GoalPreferredWorkOptions",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "userGoals(first:1000000)"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '3cefd93cb5210822f9f182abd3ce5fa6';
export default node;
